import React from 'react';
import { useScript } from 'usehooks-ts';
import DevRevWidget from './DevRevWidget';

interface IDevRevWidgetProps {
	sessionToken: string;
}

const DevRevWidgetScript: React.FC<IDevRevWidgetProps> = ({ sessionToken }) => {
	const scriptStatus = useScript('https://plug.devrev.ai/descope/widget.js', {
		shouldPreventLoad: false
	});

	return (
		<DevRevWidget
			sessionToken={sessionToken}
			isLoading={scriptStatus !== 'ready'}
		/>
	);
};

export default DevRevWidgetScript;
